"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@mui/material/styles");

var _SpeedDialAction = _interopRequireDefault(require("@mui/material/SpeedDialAction"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const UqSpeedDialAction = _react.default.forwardRef(function UqSpeedDialAction(props, ref) {
  const theme = (0, _styles.useTheme)() || {};
  const themeProps = theme.wrappers ? theme.wrappers.uqSpeedDialAction : {};
  const sx = { ...(themeProps === null || themeProps === void 0 ? void 0 : themeProps.sx),
    ...props.sx
  };
  const style = { ...(themeProps === null || themeProps === void 0 ? void 0 : themeProps.style),
    ...props.style
  };
  const tRef = ref;
  return _react.default.createElement(_SpeedDialAction.default, _extends({}, themeProps, props, {
    sx: sx,
    style: style,
    ref: tRef
  }));
});

var _default = UqSpeedDialAction;
exports.default = _default;